export default __webpack_public_path__ + "static/media/ActiveUploads.c76368cf.svg";